import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import {Option} from '@Components/contextual-menu/components/option';
import {ImageThumbnailContainer} from '@Components/contextual-menu/components/image-thumbnail-container';

interface ContextualMenuImageThumbnailOptionProps {
  id: string;
  className?: string;
  label: string;
  imgSrc: string;
  onEdit(): void;
  isLoading?: boolean;
  optionTag?: ReactNode;
  thumbnailClass?: string;
}

export function ContextualMenuImageThumbnailOption({className = '', isLoading = false, thumbnailClass = '', ...props}: ContextualMenuImageThumbnailOptionProps): ReactElement {
  const onClickEditIcon = (): void => {
    props.onEdit();
  };

  return (
    <Option
      key={props.id}
      label={props.label}
      tag={props.optionTag}
      className={className}
      optionControl={<ImageThumbnailContainer isLoading={isLoading} imgSrc={props.imgSrc} onEdit={onClickEditIcon} thumbnailClass={thumbnailClass}/>}
    />
  );
}
